export class DateFormatter {
    public static getFormattedDate(date: any): string {
        if (!date) {
            return '';
        }
        try {
            date = new Date(date.time);
            return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' (dd/MM/yyyy)';
        } catch (e) {
            console.log('Cannot parse date time', date);
        }

        return 'No date';
    }

    public static getDaysLeft(nextChangeDate: Date, currentDate: Date) {
        const timeDiff = nextChangeDate.getTime() - currentDate.getTime();
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    public static getDate(date: any): Date {
        try {
            date = new Date(date.time);
            const dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            return new Date(dateString);
        } catch (e) {
            console.log('Cannot parse year time', date);
        }

        return new Date();
    }
}
